if (process.env.REACT_APP_ID === 'scotland' || window.location.toString().includes('scotland')) {
  module.exports = require('./scotland')
} else {
  module.exports = require('./waverley');
}